import { render, staticRenderFns } from "./PotentialApplicantsListArticle.vue?vue&type=template&id=2cf09fb6&"
import script from "./PotentialApplicantsListArticle.vue?vue&type=script&lang=js&"
export * from "./PotentialApplicantsListArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports